import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-users-list',
  templateUrl: './user.list.component.html'
})
export class UsersListComponent {
  
}